interface DateParts {
  day: string;
  month: string;
  year: string;
}

export class DateInputUtils {
  static generateYears(range = 'adult') {
    const year = new Date().getFullYear();
    const result = [];

    if (range === 'adult') for (let k = -17; k > -85; k--) result.push(year + k);
    else if (range === 'child') for (let k = 0; k > -17; k--) result.push(year + k);
    else if (range === 'expiry') for (let k = 0; k < 16; k++) result.push(year + k);

    return result;
  }

  static valueToParts(value: string, months: any) {
    if (value) {
      const [year, month, day] = value.split('-');
      return { day, month: months[+month - 1], year };
    }

    return { day: '', month: '', year: '' };
  }

  static partsToValue({ day, month, year }: DateParts, months: string[]): string {
    const monthIndex = months.indexOf(month) + 1;
    if (day && month && year) return `${year}-${String(monthIndex).padStart(2, '0')}-${day.padStart(2, '0')}`;

    return '';
  }
}
